/* eslint-disable no-unused-vars */



import BaseCanvasEdit2 from './base_canvas_edit_2'
import { useState, useEffect, useRef, forwardRef, useImperativeHandle } from "react"
import { Row, Col, Spin, message, Button, useCRUDController, TempDataProvider, Switch } from './ot'
import { useNavigate, useSearchParams, } from "react-router-dom";

// ─── 工具：從 response_form_value_data 取值 ──────────────────────────────────
export function getValByCode(response_form_value_data = [], code) {
    const item = response_form_value_data.find(i =>
        (i.form_column_form_value_data || []).find(c => c.code === code)
    )
    if (!item) return ''
    if (item.is_option && item.extra_data?.length) {
        const nameItem = item.extra_data.find(e =>
            (e.form_column_form_value_data || e.form_column_form_value_data2 || []).find(c => c.code === '名稱')
        )
        if (nameItem) return String(nameItem.value?.value ?? '')
    }
    return item.value?.value != null ? String(item.value.value) : ''
}

function formatDisplayValue(value) {
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) {
        return value.slice(0, 10)
    }
    return value
}

// ─── 單據唯讀欄位呈現 ─────────────────────────────────────────────────────────
// 從 response_form_value_data 提取欄位值，以標籤+數值卡片排列，無輸入框。
// visibleFields 優先：[{ code: 後台欄位代碼, label: 顯示別名 }]
// 若無 visibleFields 則依 documentColumns（form_form_column_data），最後 fallback 全部欄位
export const ReadOnlyDocumentItem = ({
    responseValue,
    columnLinks = {},
    columnOnClick = {},
    documentColumns = [],
    visibleFields = [],
}) => {
    const rfvd = responseValue?.response_form_value_data || []

    const fields = (() => {
        if (visibleFields.length > 0) {
            return visibleFields
                .map(({ code, label }) => ({
                    backendCode: code,
                    label: label || code,
                    displayValue: getValByCode(rfvd, code),
                }))
                .filter(f => f.backendCode && f.displayValue !== '' && f.displayValue != null)
        }
        if (documentColumns.length > 0) {
            return documentColumns
                .filter(col => col?.is_hidden !== '1' && col?.is_hidden !== 1)
                .map(col => ({
                    backendCode: col?.code,
                    label: col?.code,
                    displayValue: getValByCode(rfvd, col?.code),
                }))
                .filter(f => f.backendCode && f.displayValue !== '' && f.displayValue != null)
        }
        return rfvd
            .map(item => {
                const code = item?.form_column_form_value_data?.[0]?.code
                return { backendCode: code, label: code, displayValue: code ? getValByCode(rfvd, code) : '' }
            })
            .filter(f => f.backendCode && f.displayValue !== '' && f.displayValue != null)
    })()

    if (fields.length === 0) return null

    return (
        <div style={{
            padding: '6px 6px',
            display: 'flex',
            flexWrap: 'wrap',
            gap: '12px',
            alignItems: 'flex-start',
            background: '#fff',
        }}>
            {fields.map(({ backendCode, label, displayValue }) => {
                const rawLink = columnLinks[backendCode]
                const link = typeof rawLink === 'function' ? rawLink(displayValue, responseValue) : rawLink
                const handler = columnOnClick[backendCode]
                const isClickable = !!(link || handler)
                return (
                    <div
                        key={backendCode}
                        onClick={isClickable ? () => { if (handler) handler(displayValue, responseValue); else if (link) window.location.href = link } : undefined}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                            minWidth: 80,
                            cursor: isClickable ? 'pointer' : 'default',
                        }}
                    >
                        <span style={{ fontSize: 11, color: '#8c8c8c', lineHeight: 1.3 }}>{label}</span>
                        <span style={{
                            fontSize: 13,
                            fontWeight: 600,
                            color: isClickable ? '#1677ff' : '#1a1a1a',
                            textDecoration: isClickable ? 'underline' : 'none',
                            lineHeight: 1.5,
                        }}>
                            {formatDisplayValue(displayValue)}
                        </span>
                    </div>
                )
            })}
        </div>
    )
}

const FormStatic5 = forwardRef(({
    // dbCoverIdName = "form_document_id",
    response_id,    //用來判斷是要新增還是修改
    dbCoverIdName = "document_id",
    // mainApiRoute = "/form_management/backend/form_document/view",
    mainApiRoute = "/utility/document/base_view",
    reponseApiRoute = "/form_management/backend/form/response",
    responseWithoutViewApiRoute = "/utility/response/without_view",
    testFrontendRoute = '/form_management/form_static/_5',
    // resultFrontendRoute = '/form_management/form_static/_6',
    resultFrontendRoute = '/utility/form_static_6',
    dbCoverId: propsdbCoverId,
    onSubmit: propsOnSubmit = () => { },
    defaultRecord,
    renderExternalBlock,
    submitText = "送出表單",
    showSubmit = true,
    showSwitchButton = false,
    showToolbar = true,
    propsCanvasMode = "",
    onPostResponseFinish = () => { },
    defaultMode = "fill", // 設定 defaultMode 為 "fill"，表示預設為填寫模式 fill_disable 為預覽模式
    columnLinks = {},     // { [code]: string | (value) => string } — 點擊後導向頁面
    onColumnClick = {},   // { [code]: (value) => void } — 點擊後執行回呼
}, ref) => {
    const baseCanvasEdit2Ref = useRef()
    const submitTempDataRef = useRef();

    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const xDocumentId = searchParams?.get(dbCoverIdName)
    const [documentId, setDocumentId] = useState(null); // 新增
    const [canvasElement, setCanvasElement] = useState([]); //可以定義為defaultCanvasElement的值
    const [tempCanvasElement, setTempCanvasElement] = useState([]); //可以定義為CanvasElement的緩存結果
    const [columns, setColumns] = useState([])
    const [loading, setLoading] = useState(false);
    const [mode, setMode] = useState(defaultMode);

    // ── RWD：自動感知視窗寬度，切換 canvasMode ──────────────────────────────
    // 若上層有傳入 propsCanvasMode 則優先使用（不自動感知）
    const getAutoCanvasMode = () => {
        if (typeof window === "undefined") return "desktop"
        const w = window.innerWidth
        if (w >= 1024) return "desktop"
        if (w >= 640) return "tablet"
        return "mobile"
    }
    const [autoCanvasMode, setAutoCanvasMode] = useState(getAutoCanvasMode)
    useEffect(() => {
        if (propsCanvasMode) return  // 有外部指定時不啟用自動感知
        const handler = () => setAutoCanvasMode(getAutoCanvasMode())
        window.addEventListener("resize", handler)
        return () => window.removeEventListener("resize", handler)
    }, [propsCanvasMode])
    const resolvedCanvasMode = propsCanvasMode || autoCanvasMode
    // ────────────────────────────────────────────────────────────────────────

    const dbCoverId = propsdbCoverId ?? searchParams?.get(dbCoverIdName)

    const getData = (dbCoverId, selectionData) => {
        mainApiController.getData({
            [dbCoverIdName]: dbCoverId
        })
            .then((res) => {
                let data = res?.data
                let dataFirst = data?.find((_) => true)
                let document_classify_structure_type_data = dataFirst?.document_classify_structure_type_data || []
                let document_classify_structure_type_data_first = document_classify_structure_type_data?.find((_) => true)
                let document_x_canvas_content_data = document_classify_structure_type_data_first?.document_x_canvas_content_data || []
                let document_x_canvas_content_first = document_x_canvas_content_data?.find((_) => true)
                // 取得畫布內容和ID
                let canvas_content = document_x_canvas_content_first?.content || []
                canvas_content = canvas_content?.map(item => (
                    {
                        ...item,
                        elements: item?.elements?.map(itemItem => {
                            let form_form_column_data = itemItem?.form_form_column_data || []
                            let defaultValue = form_form_column_data?.[0]?.default_value
                            return {
                                ...itemItem,
                                content: defaultValue
                            }
                        })
                    }
                ))
                if (mainApiRoute === "/utility/document") {
                    document_x_canvas_content_data = dataFirst?.document_x_canvas_content_data || []
                    document_x_canvas_content_first = document_x_canvas_content_data?.find((_) => true)
                    canvas_content = document_x_canvas_content_first?.content || []
                }
                if (defaultRecord) {
                    canvas_content = canvas_content?.map(item => (
                        {
                            ...item,
                            elements: item?.elements?.map(itemItem => (
                                {
                                    ...itemItem,
                                    content: Object.keys(defaultRecord)?.includes(itemItem?.form_form_column_data?.[0]?.code) ? defaultRecord?.[itemItem?.form_form_column_data?.[0]?.code] : itemItem?.content
                                }
                            ))
                        }
                    ))
                }
                let document_form_data = document_classify_structure_type_data_first?.document_form_data || []
                let document_form_data_first = document_form_data?.find((ele) => true)
                let form_form_column_data = document_form_data_first?.form_form_column_data || []
                setColumns((pre) => {
                    let temp = form_form_column_data.map((value) => {
                        return {
                            title: value?.code,
                            key: String(value?.form_column_id),
                            dataIndex: String(value?.form_column_id),
                            align: "center",
                        }
                    })
                    return temp
                })
                if (baseCanvasEdit2Ref.current) {
                    baseCanvasEdit2Ref.current.onUpdate(canvas_content)
                }
                setCanvasElement(canvas_content)

                // 取得 document_id 並記錄
                if (mainApiRoute === "/utility/document") {
                    setDocumentId(dataFirst?.document_id || null);
                }
                else {
                    setDocumentId(document_classify_structure_type_data_first?.document_id || null);
                }

            })
            .catch((error) => {
                // 處理錯誤
            });
    }
    function convertCanvasToResponseData(pages, documentId = 1, type = 1, response_id = null) {
        // 預設只處理第一頁
        const page = Array.isArray(pages) ? pages[0] : pages;
        const response_form_value_data = [];

        (page?.elements || []).forEach((element, idx) => {
            // 只處理有 form_column_id 的元件
            if (!element.form_column_id) return;

            // 判斷是否選項型元件
            const isOption = ["dropdown", "radio_button", "multi_select_list", "checkbox"].includes(element.type) ? 1 : 0;

            // value_type
            let value_type = element.type;
            // value 格式
            let valueObj;
            if (isOption) {
                // 多選用 array，單選用 id
                if (Array.isArray(element.content)) {
                    valueObj = { value: element.content.map(v => Number(v)) };
                } else {
                    valueObj = { value: Number(element.content) };
                }
            } else {
                valueObj = { value: element.content };
            }
            let code = element?.form_form_column_data?.[0]?.code;
            response_form_value_data.push({
                code,
                form_column_form_value_data: [
                    {
                        code: element?.form_form_column_data?.[0]?.code,
                        form_column_id: element.form_column_id
                    }
                ],
                is_option: isOption,
                index: idx + 1,
                value: valueObj,
                value_type
            });
        });
        let response_value = {
            type,
            document_response_data: [
                {
                    document_id: documentId
                }
            ],
            response_form_value_data
        }
        if (response_id) {
            response_value.response_id = response_id
        }
        return [
            {
                ...response_value
            }
        ];
    }
    const onSubmit = () => {
        // 1. 檢查必填欄位
        const page = Array.isArray(tempCanvasElement) ? tempCanvasElement[0] : tempCanvasElement;
        const elements = page?.elements || [];
        let missingFields = [];

        elements.forEach((element) => {
            // 判斷是否必填
            const isRequired = element?.form_form_column_data?.[0]?.is_required === "1";
            if (isRequired) {
                // 判斷內容是否有填寫（支援 0、false、空字串都算沒填）
                const value = element?.content;
                const isEmpty = value === undefined || value === null || value === "" || (Array.isArray(value) && value.length === 0);
                if (isEmpty) {
                    missingFields.push(element?.form_form_column_data?.[0]?.code || "未命名欄位");
                }
            }
        });

        if (missingFields.length > 0) {
            message.error(`請填寫所有必填欄位：${missingFields.join("、")}`);
            return;
        }

        // 2. 通過檢查才送出
        const responseData = convertCanvasToResponseData(tempCanvasElement, documentId, "1", response_id);
        submitTempDataRef.current = responseData;
        if (response_id) {
            responseUtilityController.patchData(responseData)
        }
        else {
            responseWithoutUtilityController.postData(responseData)
            // responseUtilityController.postData(responseData);
        }
    }
    const mainApiController =
        useCRUDController({
            onFinish: ({ axiosMode, status, values }) => {
                if (status === "success") {
                    if (axiosMode === "post") {
                        message.success("新增成功")
                        // navigate(`${pageFrontendRoute}?` + jsonToQueryString({ [dbCoverIdName]: values?.[dbCoverIdName] }))
                    } else if (axiosMode === "patch") {
                        message.success("修改成功")
                        getData(dbCoverId)
                    }
                }
                else if (status === "error") {
                    if (axiosMode === "post") {
                        message.error("新增失敗")
                    }
                    else if (axiosMode === "patch") {
                        message.error("修改失敗")
                    }
                }
                setLoading(false)
            },
            onBefore: ({ axiosMode, status, values }) => {
                setLoading(true)
            },
            apiRoute: mainApiRoute,
        });

    const responseUtilityController = useCRUDController({
        apiRoute: reponseApiRoute,
        onBefore: ({ axiosMode }) => {
            if (axiosMode !== "get") {
                setLoading(true);
            }
        },
        onFinish: ({ axiosMode, status, values }) => {
            if (status === "success") {
                if (axiosMode === "post") {
                    if (propsOnSubmit) {
                        // const responseData = convertCanvasToResponseData(tempCanvasElement, documentId, "1");
                        propsOnSubmit(submitTempDataRef.current, values)

                    } else {
                        message.success("新增成功")
                    }
                    // setReloadAndResetCount((pre) => pre + 1)
                } else if (axiosMode === "patch") {
                    // message.success("修改成功")
                    // setReloadCount((pre) => pre + 1)
                    propsOnSubmit(submitTempDataRef.current, values)

                }
                else if (axiosMode === "delete") {
                    message.success("刪除成功")
                    // setReloadAndResetCount((pre) => pre + 1)

                }
            }
            else if (status === "error") {
                if (axiosMode === "post") {
                    message.error("新增失敗")
                    // setReloadAndResetCount((pre) => pre + 1)

                }
                else if (axiosMode === "patch") {
                    message.error("修改失敗")
                    // setReloadCount((pre) => pre + 1)
                }
                else if (axiosMode === "delete") {
                    message.error("刪除失敗")
                    // setReloadAndResetCount((pre) => pre + 1)
                }
            }
            if (axiosMode !== "get") {
                setLoading(false)
                // setModalOpen(false);
            }
        }
    })
    const responseWithoutUtilityController = useCRUDController({
        apiRoute: responseWithoutViewApiRoute,
        onBefore: ({ axiosMode }) => {
            if (axiosMode !== "get") {
                setLoading(true);
            }
        },
        onFinish: ({ axiosMode, status, values }) => {
            if (status === "success") {
                if (axiosMode === "post") {
                    if (propsOnSubmit) {
                        // const responseData = convertCanvasToResponseData(tempCanvasElement, documentId, "1");
                        propsOnSubmit(submitTempDataRef.current, values)

                    } else {
                        message.success("新增成功")
                    }
                    // setReloadAndResetCount((pre) => pre + 1)
                } else if (axiosMode === "patch") {
                    // message.success("修改成功")
                    // setReloadCount((pre) => pre + 1)
                    propsOnSubmit(submitTempDataRef.current, values)

                }
                else if (axiosMode === "delete") {
                    message.success("刪除成功")
                    // setReloadAndResetCount((pre) => pre + 1)

                }
            }
            else if (status === "error") {
                if (axiosMode === "post") {
                    message.error("新增失敗")
                    // setReloadAndResetCount((pre) => pre + 1)

                }
                else if (axiosMode === "patch") {
                    message.error("修改失敗")
                    // setReloadCount((pre) => pre + 1)
                }
                else if (axiosMode === "delete") {
                    message.error("刪除失敗")
                    // setReloadAndResetCount((pre) => pre + 1)
                }
            }
            if (axiosMode !== "get") {
                setLoading(false)
                // setModalOpen(false);
            }
        }
    })

    useEffect(() => {
        getData(dbCoverId)
    }, [dbCoverId, defaultRecord])

    // 暴露給父元件的操作方法：
    // - submit(): 觸發送出流程（同按下送出按鈕）
    // - getResponseData(): 取得最近一次準備好的 response payload
    useImperativeHandle(ref, () => ({
        submit: () => onSubmit(),
        getResponseData: () => submitTempDataRef.current ?? convertCanvasToResponseData(tempCanvasElement, documentId, "1", response_id),
    }))

    return (<Row>
        {showSwitchButton && <Col span={24} >
            <Row>
                <Col>
                    顯示模式：
                </Col>
                <Col>
                    <Switch
                        checkedChildren="填寫模式"
                        unCheckedChildren="預覽模式"
                        checked={mode === "fill"}
                        onChange={(e) => {
                            let checked = e.target.value
                            setMode(checked ? "fill" : "fill_disable")
                        }} />
                </Col>
            </Row>
        </Col>}
        <Col span={24}>
            <Spin size={40} spinning={loading}>
                {showSubmit && <div
                    className="sticky bottom-0 left-0 w-full flex justify-end p-4 bg-white shadow z-10"
                    style={{ marginTop: "0.5rem" }}
                >
                    <Button
                        type="primary"
                        size="lg"
                        onClick={onSubmit}
                        loading={loading}
                    >
                        {submitText}
                    </Button>
                </div>}
                <TempDataProvider >
                    <div className="flex h-screen bg-gray-50 w-full h-90vh overflow-auto ">
                        <BaseCanvasEdit2
                            mode={mode}
                            ref={baseCanvasEdit2Ref}
                            elements={canvasElement}
                            tools={[
                                // {
                                //     label: "測試頁面",
                                //     onClick: () => {
                                //         navigate(`${testFrontendRoute}?${dbCoverIdName}=${dbCoverId}`)
                                //     }
                                // },
                                {
                                    label: "結果頁面",
                                    onClick: () => {
                                        navigate(`${resultFrontendRoute}?${dbCoverIdName}=${dbCoverId}`)
                                    }
                                },
                            ]}
                            onCanvasPageChange={(page) => {
                                setTempCanvasElement(page)
                            }}
                            renderExternalBlock={renderExternalBlock}
                            showToolbar={showToolbar}
                            propsCanvasMode={resolvedCanvasMode}
                        />
                    </div>
                </TempDataProvider>
                {mode === "fill_disable" && (() => {
                    const allCodes = [...new Set([...Object.keys(columnLinks), ...Object.keys(onColumnClick)])]
                    if (allCodes.length === 0) return null
                    const page = Array.isArray(tempCanvasElement) ? tempCanvasElement[0] : tempCanvasElement
                    const elements = page?.elements || []
                    const chips = allCodes.flatMap(code => {
                        const el = elements.find(e => e?.form_form_column_data?.[0]?.code === code)
                        const value = el?.content
                        if (value === undefined || value === null || value === '') return []
                        const link = typeof columnLinks[code] === 'function' ? columnLinks[code](value) : columnLinks[code]
                        const handler = onColumnClick[code]
                        return [{ code, value, link, handler }]
                    })
                    if (chips.length === 0) return null
                    return (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', padding: '6px 8px' }}>
                            {chips.map(({ code, value, link, handler }) => (
                                <span
                                    key={code}
                                    style={{
                                        display: 'inline-flex', alignItems: 'center', gap: 4,
                                        padding: '3px 10px', background: '#f0f5ff',
                                        border: '1px solid #adc6ff', borderRadius: 12,
                                        fontSize: 12, color: '#2f54eb', cursor: 'pointer',
                                        userSelect: 'none',
                                    }}
                                    onClick={() => handler ? handler(value) : link && navigate(link)}
                                >
                                    {code}：{value}
                                </span>
                            ))}
                        </div>
                    )
                })()}
                
            </Spin>
        </Col >
    </Row >)
})

export default FormStatic5
